/* global axios */
import ApiClient from '../ApiClient';

class SlotsConfigAPI extends ApiClient {
  constructor() {
    super('omni/slots_config', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/omni/slots_config
  // GET /api/v1/accounts/:account_id/omni/slots_config?agent_bot_id=X
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/omni/slots_config/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/omni/slots_config
  create(data) {
    return axios.post(this.url, data);
  }

  // PATCH /api/v1/accounts/:account_id/omni/slots_config/:id
  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/omni/slots_config/:id
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // DELETE /api/v1/accounts/:account_id/omni/slots_config/:id/remove_file
  removeFile(id) {
    return axios.delete(`${this.url}/${id}/remove_file`);
  }

  // GET /api/v1/accounts/:account_id/omni/slots_config/bots
  getBots() {
    return axios.get(`${this.url}/bots`);
  }

  // PATCH /api/v1/accounts/:account_id/omni/slots_config/bots/:id
  updateBot(id, data) {
    return axios.patch(`${this.url}/bots/${id}`, data);
  }

  // GET /api/v1/accounts/:account_id/omni/slots_config?agent_bot_id=X
  getByBot(agentBotId) {
    return axios.get(this.url, {
      params: { agent_bot_id: agentBotId },
    });
  }

  // POST /api/v1/accounts/:account_id/omni/slots_config/test_api_call
  testApiCall({ url, method, headers, body, timeoutMs, saveSample, slotId }) {
    return axios.post(`${this.url}/test_api_call`, {
      url,
      method,
      headers,
      body,
      timeout_ms: timeoutMs,
      save_sample: saveSample,
      slot_id: slotId,
    });
  }

  // GET /api/v1/accounts/:account_id/omni/slots_config/fields_catalog?agent_bot_id=X
  getFieldsCatalog(agentBotId, { excludeSlotId } = {}) {
    return axios.get(`${this.url}/fields_catalog`, {
      params: {
        agent_bot_id: agentBotId,
        exclude_slot_id: excludeSlotId,
      },
    });
  }
}

export default new SlotsConfigAPI();

